import {type FC, useCallback} from 'react';
import ReactModal from 'react-modal';

import type {GetComponentProps} from '@yourcoach/shared/utils/utility-types';

import CloseIcon from '@yourcoach/shared/assets/icons/close.svg';

import type {Props} from './types';

import * as S from './styles';

ReactModal.setAppElement('#root');

export const ReactModalAdapter: FC<Props> = ({
  children,
  disableBodyScroll,
  title,
  ...rest
}: Props) => {
  const contentClassName = 'content';
  const overlayClassName = 'overlay';

  const onAfterOpen = useCallback(
    (...args) => {
      if (disableBodyScroll) {
        document.body.style.overflow = 'hidden';
      }

      if (rest.onAfterOpen) {
        rest.onAfterOpen(...args);
      }
    },
    [disableBodyScroll, rest],
  );

  const onAfterClose = useCallback(() => {
    if (disableBodyScroll) {
      document.body.style.overflow = 'auto';
    }

    if (rest.onAfterClose) {
      rest.onAfterClose();
    }
  }, [disableBodyScroll, rest]);

  const onCloseButtonClick: GetComponentProps<
    (typeof S)['CloseButton']
  >['onClick'] = useCallback(
    e => {
      rest.onRequestClose?.(e.event.DOMEvent!);
    },
    [rest],
  );

  return (
    <ReactModal
      closeTimeoutMS={200}
      {...rest}
      className={contentClassName}
      onAfterClose={onAfterClose}
      onAfterOpen={onAfterOpen}
      overlayClassName={overlayClassName}
      // @ts-expect-error: TODO: fix this
      portalClassName={rest.className}
    >
      <>
        {title && (
          <S.Header>
            {typeof title === 'function' ? title() : title}
            <S.CloseButton onClick={onCloseButtonClick}>
              <CloseIcon />
            </S.CloseButton>
          </S.Header>
        )}
        {children}
      </>
    </ReactModal>
  );
};
